export default class ContactChannelModel {
  id!: number;

  descricao!: string;
}
